import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

import * as _ from 'lodash';
@Component({
  selector: 'app-cc-email-and-sms',
  templateUrl: './cc-email-and-sms.component.html',
  styleUrls: ['./cc-email-and-sms.component.scss']
})
export class CcEmailAndSmsComponent implements OnInit {

  modalType: String = "";
  smsFields: any = [];
  emailFields: any = [];
  validationError: String = "";
  message: String = "";
  constructor(
    public dialogRef: MatDialogRef<CcEmailAndSmsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {},
    private _snackBar: MatSnackBar
  ) { }

  ngOnInit() {
    this.onInit();
  }

  onInit() {
    this.modalType = this.data["type"];
    if (this.modalType === "sms") {
      this.smsFields.push("");
    } else {
      this.emailFields.push({ value: "" });
    }
  }

  addNewField() {
    if (this.modalType === "sms") {
      this.smsFields.push("");
    } else {
      this.emailFields.push({ value: "" });
    }
  }

  onNoClick() {
    this.dialogRef.close({ result: false });
  }

  trackByFn(index) {
    return index;
  }

  optionValueChange(i, type, value) {
    if (type === "sms") {
      this.smsFields[i] = value;
    } else {
      this.emailFields[i] = { value: value };
    }
  }

  send() {
    let validityCheck = true;
    if (this.modalType === "sms") {
      if (this.smsFields.length > 0) {
        let sms: any = [];
        this.smsFields.forEach((phone) => {
          if (phone.length > 0) {
            const re = /^([0|\+[0-9]{1,5})?([7-9][0-9]{9})$/;
            let valid = re.test(String(phone).toLowerCase());
            if (!valid) {
              this.openSnackBar(phone + " is not a valid phone number");
              validityCheck = false;
              return;
            } else {
              sms.push(phone);
            }
          }
        });
        this.dialogRef.close({ result: true, data: sms, message: this.message });
      }
    } else {
      if (this.emailFields.length > 0) {
        let emails: any = [];
        (this.emailFields.map((emailObj) => { return emailObj.value })).forEach((email: string) => {
          if (email.length > 0) {
            const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            let valid = re.test(String(email).toLowerCase());
            if (!valid) {
              this.openSnackBar(email + " is not a valid email");
              validityCheck = false;
              return;
            } else {
              emails.push(email);
            }
          }
        });
        (validityCheck) ? this.dialogRef.close({ result: true, data: emails, message: this.message }) : null;
      }
    }
  }

  openSnackBar(message) {
    this._snackBar.open(message, "Ok", {
      duration: 2000
    });
  }
  onMessageChange(msg) {
    this.message = msg;
  }
}
